module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "t004"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter One")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nocent"
  }, [_vm._v("Stardate: 41211.0 Captain’s Log, Supplemental")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Enterprise")]), _vm._v(" continues on its mission to Archaria III, a planet jointly colonized by humans and Peladians. A new disease has cropped up, terrifying the inhabitants. So far, more than five thousand cases have been confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The only drug at all effective in treating this disease is a rare compound called Tricillin PDF, which seems to prolong life, though only for a week at most. The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Enterprise")]), _vm._v(" will deliver a supply of the drug, quarantine the planet, then stay to oversee research into finding a cure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND RENDER WHATEVER AID")]), _vm._v(" the Archarians require until the emergency is over,” Captain Picard said, leaning forward at the conference table and gazing at each of his senior staff in turn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William Riker, Geordi La Forge, and Worf looked uncomfortable at the mention of the plague,"), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v(" and he didn’t blame them; he had always felt ill at ease when faced with intangible dangers. Deanna Troi looked deeply concerned, and Dr. Crusher looked … intrigued? "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("She has dealt with plagues before,")]), _vm._v(" Picard reminded himself. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("She knows how to contain them.")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The persistent low rumble of a starship at maximum warp filled the room. None of his crew spoke. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("They feel the tension building already,")]), _vm._v(" he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Captain,” Dr. Crusher finally said, “I may have to bring samples of this virus aboard the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Enterprise")]), _vm._v(" for study, and perhaps a few patients.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Understood, Doctor. So long as all necessary security precautions are maintained, I see no problem. In the meantime”—he slid a data padd across the conference table to her—“the doctors of Archo City Hospital have prepared a full report, which you may find useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you.” She pulled the padd in front of herself and began skimming the opening remarks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something else is troubling you, sir,” Deanna Troi said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard hesitated, then gave a curt nod. Best to get it out in the open. “What disturbs me most is the thought that this whole problem may be of our own manufacture … a biological weapon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Impossible—how could that be?” Riker said, shaking his head dismissively. “Legalities aside, it’s against everything the Federation stands for!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“We do have treaties with most sentient races which prevent the development and use of biological weapons,” Data said. “With all due respect, sir,")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v(" the deployment of a genetically designed plague on a remote agricultural world such as Archaria III seems highly unlikely.”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not necessarily,” Picard said. He cleared his throat. “Archaria III is in many ways a throwback to human civilization two or three hundred years ago. It was settled by religious zealots early in the twenty-second century, and although they have largely come into the Federation’s fold, old prejudices and resentments still bubble to the surface from time to time.” The room was quiet for a moment while Picard allowed his point to sink in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riker finally broke the silence. “Sir, if I may ask, what is it that leads you to conclude this disease is a weapon?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Might")]), _vm._v(" be a weapon, Number One. A radical political group called the Purity League claims the plague is an act of God against ‘blasphemous unnatural unions.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riker gave him a blank stare. “Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard cleared his throat. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("How to phrase this delicately.")]), _vm._v(" He said, “The Purity League is opposed to interspecies mating—‘mixers’ as they call such people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again the rumble of the ship’s engines filled the room. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("They can’t believe it, either,")]), _vm._v(" he thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Humanity is supposed to be beyond such prejudices.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("He noticed that Deanna Troi, half human and half Betazoid herself, hid her inner feelings behind a mask of professional calm. He would have given a lot to know her true reaction. Undoubtedly she was even more shocked and horrified than he had been.")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("To think that some humans are still capable of such petty resentments")]), _vm._v("….")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He forced himself back to the problem at hand. “Mixers—or anyone else suspected of adulterating the purity of the human race—are treated as second-class citizens in many places on Archaria III,” he continued. “Officially such prejudices are prohibited, of course, but in the backwater towns discrimination apparently still runs rampant. Only in the half-dozen large cities do humans and Peladians work and live together with something approaching harmony. In the country, things have apparently become so bad that most full-blooded Peladians now live in isolated enclaves surrounded by their own kind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riker said, “That sounds like a ghetto system.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is. Those of mixed heritage are even less fortunate, since they belong fully to neither the human nor the Peladian world. They were relocating to the cities in record numbers—until the plague struck. Now they’re fleeing into the countryside once more, living like vagabonds in tent camps.” Picard looked down at his clenched, interlaced fingers resting uneasily on the table. He didn’t bother to feign relaxation. Sometimes it was good for the crew to see him share their anger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deanna Troi asked, “How many people of mixed blood are on the planet?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("“Nobody is quite sure. Estimates range from between 150,000 and 200,000 people. Obviously, those mixers who most closely resemble humans")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v(" hide the truth to avoid conflict with the Purity League.”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Data said, “I am aware of the Purity League, sir. The Federation has monitored their activities for many years, but has deemed them a minor nuisance with little actual influence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Their influence is growing,” Picard said firmly. The private reports he had read gave alarming statistics; according to confidential surveys, fully half of the planet’s human population harbored feelings of support for the Purity League, though the League’s actual membership numbers were open to conjecture. It was certainly in the tens of thousands if not the hundreds of thousands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He went on. “The Purity League’s leader, Father Veritas, is using the plague as a rallying point for anti-alien sentiment. Apparently Veritas is responsible for inciting dozens of race riots in the last few months. The whole planet is in turmoil. The non-human population—and especially the partly human population—is running scared. The plague’s growth has only served to make the situation worse.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“Veritas,” indeed,")]), _vm._v(" he thought, grimacing. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("If ever there was a misnomer")]), _vm._v("….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir,” said Deanna Troi, “Archaria III has a long history of interspecies problems, including wars, assassinations, and racism. Its history is part of several planetary evolution courses at the Academy. I believe everyone here has studied it to some degree.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("A general murmur of agreement came from the")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v(" rest of his senior staff. Picard found himself surprised—it hadn’t been part of the curriculum when he had studied at the Academy—but he was pleased. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("They’re keeping up with the times.")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is correct, sir,” said Data. “It was settled in 2102 by a human sect of religious fundamentalists called the Brotherhood. Seven years later, these human settlers encountered Peladian settlers, who had colonized the planet almost simultaneously.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard had never seen a Peladian and knew little about them, beyond the fact that they were humanoid, militant about privacy, and generally considered pacifists … except when provoked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Data went on, “After a series of small wars, as the two sides got to know each other, peaceful relations and coexistence began. According to the information I have accessed, with the increasing agricultural importance of Archaria III their differences were largely put aside, in favor of economic cooperation.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“That is the public story,” Picard said. He folded his arms and frowned a bit. “There have always been tensions. Until Father Veritas and the Purity League burst onto the scene sixteen years ago, the planetary government managed to contain most of the problems before they escalated. Over the past few years, though, there has been an increase in terrorism on Archaria III aimed at Peladians, at humans who have married them, and especially at their children—all in the name of human racial purity. That’s another reason why the Federation")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v(" suspects the plague may be genetically engineered.”")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, sir,” Riker said. “I’m still not quite clear on what leads you to that conclusion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard looked at Dr. Crusher. “Doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked up from scanning her report. “All the victims are of mixed genetic origins,” she said flatly. “Not just human-Peladian, but several other genetic mixes have been affected as well. Human-Vulcan, human-Etrarian, and human-Bajoran crossbreeds are all reported susceptible to infection. Pure human and pure Peladian genetic stock appear to be immune. I would strongly suggest that no one of mixed heritage be allowed access to the planet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The news cooled the room. Worf glared. Riker folded his arms and frowned pensively, though he kept glancing almost surreptitiously at Deanna Troi. And Deanna herself gave the slightest hiss of anger—she was the most threatened of those present, Picard knew, since she was half human and half Betazoid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked pointedly in her direction. She returned his gaze, but whatever emotion had escaped her tight control had been suppressed once more behind that professional, clinical wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Counselor, counsel thyself,")]), _vm._v(" he thought.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Dr. Crusher continued, “The symptoms come on very quickly. Apparently the virus enters the mouth or nasal passages and primary multiplication occurs in lymphoid tissues. Small amounts of")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v(" virus reach the blood and are carried to other sites in the reticuloendothelial system, where they multiply quickly. High fever and severe abdominal cramping are part of the first stage. Then small white fever blisters begin to cover the body, especially the face, neck, and under the arms. This second stage lasts from one to three days. Infected patients lapse into comas by this point—and it’s probably just as well. The pain would be extreme as the muscle cramping worsens and fever blisters form in their mouths, throats, and lungs. Victims begin to suffocate. Next comes stage three, when blood begins to ooze from the gums, nose, and ears. Rapid cellular degeneration follows. Total systemic collapse is inevitable and occurs within a week of infection—often within three to four days.”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Picard swallowed. Her matter-of-fact tone did not mitigate the gruesome truth about the disease. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Pain. Unconsciousness. Suffocation. Cellular degeneration. Death.")]), _vm._v(" He had long harbored a secret fear of death by disease, by something slow and insidious worming its way through his body millimeter by millimeter. He liked enemies he could see, touch, and outsmart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Could")]), _vm._v(" such a disease be genetically engineered?” he asked her. No sense avoiding the inevitable question.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Could someone create such a disease? Yes, I can think of half-a-dozen research labs capable of cobbling it together with a few months of hard work. I think the real question is, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("did")]), _vm._v(" someone. It’s much too soon to say whether this disease has been")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v(" genetically engineered…. It could just as easily be a virus which has mutated to attack some previously unknown weakness in the immune system of genetic crosses.”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“How likely is "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that?")]), _vm._v("” Riker asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know.” She hesitated. “I really can’t comment until I get a sample of the virus and break it down with a microscanner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our mission is to find out,” Picard said. He looked at each of his senior staff in turn. “If this plague is a biological weapon, it must be contained, an antidote must be found, and the designers must be brought to justice before more damage can be done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Crusher nodded. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Set her on course,")]), _vm._v(" Picard thought, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and she’ll work wonders.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll begin work with Archarian doctors at once,” she said, “to try to find a cure. With so many people infected, that must be my first priority. I’ll beam down with my team and begin work immediately.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Agreed,” said Picard. “Unless you have an objection, Doctor, I want an away team to beam down to investigate the Purity League. If they are responsible, they might already have a cure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That shouldn’t be a problem, as long as no member of the away team is of mixed genetic heritage. And of course anyone who leaves must be fully decontaminated and possibly even quarantined before resuming normal duties aboard the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Enterprise.”")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“Very good.”")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to head up that away team,” Riker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My thoughts exactly, Number One. Take two people with you. Use native costumes. This will be a strictly undercover mission. No one, not even the planetary governor, must know about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Understood, sir,” said Riker. “With your permission, I’ll take Lieutenant Yar and Lieutenant Commander Data.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Picard nodded. “Very well, Number One. Any other questions?” He glanced around the table one last time, but nobody spoke. They knew their jobs, just as he knew he could depend on them.")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b311c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/004.vue
// module id = 75
// module chunks = 0